import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { NbButton, NbInput } from "../components/nb";
import { Heart } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [stage, setStage] = useState("request"); // request | reset
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const requestReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.reset_token) {
        setToken(data.reset_token);
        toast.success("Reset link generated (mock). Enter a new password.");
        setStage("reset");
      } else {
        toast.success("If that email exists, a reset link was sent.");
      }
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const doReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! You can log in now.");
      setStage("done");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-6">
          <img src="/logo.png" alt="qrcupid" className="h-20 w-auto" />
        </Link>
        <div className="bg-white nb-border-thick nb-shadow-lg p-8">
          {stage === "request" && (
            <>
              <h1 className="font-head font-black text-3xl mb-1">Reset password</h1>
              <p className="text-gray-600 font-medium mb-6">Enter your email to get a reset link.</p>
              <form onSubmit={requestReset} className="space-y-4">
                <NbInput data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
                <NbButton type="submit" data-testid="forgot-submit" disabled={loading} className="w-full">{loading ? "Sending..." : "Send Reset Link"}</NbButton>
              </form>
            </>
          )}
          {stage === "reset" && (
            <>
              <h1 className="font-head font-black text-3xl mb-1">New password</h1>
              <p className="text-gray-600 font-medium mb-6">Choose a new password.</p>
              <form onSubmit={doReset} className="space-y-4">
                <NbInput data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" />
                <NbButton type="submit" data-testid="reset-submit" disabled={loading} className="w-full">{loading ? "Resetting..." : "Reset Password"}</NbButton>
              </form>
            </>
          )}
          {stage === "done" && (
            <div className="text-center">
              <h1 className="font-head font-black text-3xl mb-3">All set!</h1>
              <p className="text-gray-600 font-medium mb-6">Your password has been reset.</p>
              <NbButton as={Link} to="/login" className="w-full">Back to Login</NbButton>
            </div>
          )}
          <p className="text-center text-sm font-medium mt-6"><Link to="/login" className="font-bold text-[#8B1E3F] hover:underline">Back to login</Link></p>
        </div>
      </div>
    </div>
  );
}
